import {TrainView} from "./TrainView";
import {LayoutDimData} from "../../../../core/utils/ResizeHelper";
import {PREngineManager} from "../../../punkEngine/PREngineManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {PunkRocker} from "../../../PunkRocker";
import {gsap} from "gsap";
import {GameConfig} from "../../../config/base/GameConfig";

export class TrainsManager extends PIXI.Container {

    private bottomTrainVisible: boolean = false;

    constructor() {
        super();
        this.name = "TrainsManager";

        this.init();
        this.onResize();
    }

    private _topTrain: TrainView;

    get topTrain(): TrainView {
        return this._topTrain;
    }

    private _bottomTrain: TrainView;

    get bottomTrain(): TrainView {
        return this._bottomTrain;
    }

    onResize() {
        const scaledReelDim: LayoutDimData = this.bottomTrainVisible ? PREngineManager.dimScaled : PREngineManager.dim;

        if (NolimitApplication.isLandscape && this.bottomTrainVisible) {
            this.topTrain.position = new PIXI.Point(360, 85);
            this.bottomTrain.position = new PIXI.Point(360, 630);
        } else {
            this.topTrain.position = new PIXI.Point(360, 90);
            this.bottomTrain.position = new PIXI.Point(360, 690);
        }
        this.topTrain.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
        this.bottomTrain.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
    }

    public onBottomTrainShow(flag: boolean, isRestore: boolean = false): void {
        this.bottomTrainVisible = flag;
        const scaledReelDim: LayoutDimData = flag ? PREngineManager.dimScaled : PREngineManager.dim;

        if (flag) {
            gsap.to(this.topTrain.position, {
                x: 360,
                y: NolimitApplication.isLandscape ? 85 : 90,
                duration: isRestore ? 0.001 : GameConfig.FRAME_EXPAND_DUR
            });
            gsap.to(this.bottomTrain.position, {
                x: 360,
                y: NolimitApplication.isLandscape ? 630 : 690,
                duration: isRestore ? 0.001 : GameConfig.FRAME_EXPAND_DUR
            });
            gsap.to([this.topTrain.scale, this.bottomTrain.scale], {
                x: scaledReelDim.scale.x,
                y: scaledReelDim.scale.y,
                duration: isRestore ? 0.001 : GameConfig.FRAME_EXPAND_DUR
            });
        } else {
            this.topTrain.position = new PIXI.Point(360, 90);
            this.topTrain.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
            this.bottomTrain.position = new PIXI.Point(360, 690);
            this.bottomTrain.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
        }
    }

    public toggleBottomTrain(showBottomTrain: boolean, isRestoreState: boolean = false): void {
        this.onBottomTrainShow(showBottomTrain, isRestoreState);
        PunkRocker.background.onBottomTrainShow(showBottomTrain, isRestoreState);
        PunkRocker.fadedWinView.onBottomTrainShow(showBottomTrain, isRestoreState);
        PunkRocker.reelEngineManager.onBottomTrainShow(showBottomTrain);
        PunkRocker.jumpWilds.onBottomTrainShow(showBottomTrain, isRestoreState);
        PunkRocker.overlayAnim.onBottomTrainShow(showBottomTrain, isRestoreState);
        PunkRocker.waysCounter.onBottomTrainShow(showBottomTrain, isRestoreState);
        PunkRocker.noService.onBottomTrainShow(showBottomTrain, isRestoreState);
        PunkRocker.posterManager.onBottomTrainShow(showBottomTrain, isRestoreState);
        PunkRocker.otherOverlays.onBottomTrainShow(showBottomTrain, isRestoreState);
        PunkRocker.foreground.onBottomTrainShow(showBottomTrain, isRestoreState); // #365
    }

    public getMaxDuration(animName: string): number {
        const topTrainExitDur: number = this.topTrain.getAnimDuration(animName),
            bottomTrainExitDur: number = this.bottomTrain.getAnimDuration(animName);

        return Math.max(topTrainExitDur, bottomTrainExitDur);
    }

    private init(): void {
        this._topTrain = this.addChild(new TrainView("topTrain", false));
        this._bottomTrain = this.addChild(new TrainView("bottomTrain", false));
    }
}